'use strict';

module.exports = {
  resultTypes: require('./src/resultTypes'),
  client: require('./src/searchInterface')
};


//////////////////
// WEBPACK FOOTER
// ./~/gramene-search-client/index.js
// module id = 89
// module chunks = 0